<div class="wccard p-3 mb-1">
    <app-companypage-ai [requestaidata]="diversitydataAI" [currentCompanyName]="currentCompanyName" [insightstabname]="'diversity'" [totalcount]="totalFunctionResultCount" ></app-companypage-ai>
</div>

<!-- This section hides because of complience issues -->
<!-- <div class="d-flex">
  
    <div class="wccard p-3" style="margin: 0px 8px 8px 0px; width: 50%;">
        <div class="loader text-center align-content-center" style="height: 100%;" *ngIf="isNationalityPending">
            <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
        </div>
        <div *ngIf="!isNationalityPending">
            <div class="f-16 font-weight-600">What is the talent’s nationality?</div>
            <fusioncharts type="bar2d" [dataSource]="nationalityChart" width="100%"></fusioncharts>
            <p class="mb-0 f-10 line-height-1 text-484b59" *ngIf="this.nationalityChart?.data?.length">
                <span class="font-weight-600">Disclaimer:</span> This graph shows inferred insights generated using Webbtree's proprietary algorithm, based on available data. While informative, these estimates may not fully reflect the actual characteristics of individuals.
              </p>
        </div>
    </div>

  
    <div class="wccard p-3" style="margin-bottom: 8px; width: 50%;">
        <div class="loader text-center align-content-center" style="height: 100%;" *ngIf="isEthnicityPending">
            <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
        </div>
        <div *ngIf="!isEthnicityPending">
            <div class="f-16 font-weight-600">What is the talent’s ethnicity?</div>
            <fusioncharts type="doughnut2d" [dataSource]="ethnicityChart" width="100%"></fusioncharts>
            <p class="mb-0 f-10 line-height-1 text-484b59" *ngIf="this.ethnicityChart?.data?.length">
                <span class="font-weight-600">Disclaimer:</span> This graph shows inferred insights generated using Webbtree's proprietary algorithm, based on available data. While informative, these estimates may not fully reflect the actual characteristics of individuals.
              </p>
        </div>
    </div>
</div> -->

<div class="wccard p-3 mb-2">
    <p class="f-16 mb-6 font-weight-600">How diverse is the talent pool compared to other industries?</p>
    <div class="row mb-3">
        <div class="col">
            <div class=" d-flex justify-content-center">
                <!-- <span class="smallLogo"></span> -->
                <span>{{companyDetails?.name | titlecase}}</span>
            </div>
        </div>
        <div class="col">
            <div class=" text-center">
                <select data-testid="auto-app-diversity-tab-select-1" name="" class="newSelectInput" id="" (change)="filterselected($event)"
                    [(ngModel)]="selectedFunction">
                    <option [value]="app" *ngFor="let app of dropDownMenu">{{cleanCompanyName(app) | titlecase}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div>
                <div class="text-center">
                    <div class="col">
                        <div *ngIf="!genderChart?.data?.length">
                            <div class="loader text-center" *ngIf="!genderemptystate">
                                <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                            </div>
                            <div class="text-center" *ngIf="genderemptystate">
                                <p class="text-center small p-5">No Data Available</p>
                            </div>
                        </div>
                      
                        <fusioncharts width="100%" type="doughnut2d" [dataSource]="genderChart"
                            *ngIf="genderChart?.data?.length">
                        </fusioncharts>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">
            <div>
                <div class="text-center">
                    <div class="col">
                        <div *ngIf="!genderChartByFunction?.data?.length">
                            <div class="loader text-center" *ngIf="!functiongenderemptystate">
                                <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                            </div>
                            <div class="text-center" *ngIf="functiongenderemptystate">
                                <p class="text-center small p-5">No data to display</p>
                            </div>
                        </div>
                        
                        <fusioncharts width="100%" type="doughnut2d" [dataSource]="genderChartByFunction"
                            *ngIf="genderChartByFunction?.data?.length">
                        </fusioncharts>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="wccard p-3 mb-1">
    <p class="f-16 mb-6 font-weight-600">Diversity by titles</p>

    <div class="mt-2">
        <table mat-table [dataSource]="diversityTable" class="mat-elevation-z8" style="width: 100%; box-shadow: none;" matSort #diversityTbSort="matSort" (matSortChange)="manualSort()">

            <!-- key -->
            <ng-container matColumnDef="key">
                <th mat-header-cell mat-header-cell *matHeaderCellDef style="width: 150px;">
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj['Function']}} </p>
                </th>
                <td mat-cell *matCellDef="let element" class="col-3 text-484b59" style="font-family: 'Poppins', sans-serif;">
                    {{cleanCompanyName(element.key) | titlecase}}
                </td>
            </ng-container>

            <!-- doc_count -->
            <ng-container matColumnDef="doc_count">
                <th class="text-center" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by doc count" style="width: 200px;">
                    <p class="text-9696 f-12 ml-6">{{tableHeaderObj['TalentCount']}} </p>
                </th>
                <td mat-cell *matCellDef="let element" class="col-2">
                    <span class="mx-6 text-484b59 font-weight-600 pointer" (click)="handelRedirection('functions', element.key)">{{element.doc_count | number }}</span>
                </td>
            </ng-container>
            <!-- male -->
            <ng-container matColumnDef="male" >
              <th class="" mat-header-cell *matHeaderCellDef style="width: 200px;" mat-sort-header sortActionDescription="Sort by male">
                  <p class="text-9696 f-12 ml-6"><i class="fas fa-male" style="color: #B9CFF9!important;"></i> {{tableHeaderObj["Men"]}} </p>
              </th>
              <td mat-cell *matCellDef="let element" class="col-2" >
                  <span class="mx-6 text-484b59">{{element?.male != null ? element?.male+'%': '0'}}</span>
              </td>
          </ng-container>

            <ng-container matColumnDef="graph">
                <th class="" mat-header-cell *matHeaderCellDef style="width: 150px;">
                    <p class="text-9696 f-12 text-left ml-0"> {{tableHeaderObj["GenderRatio"]}} </p>
                </th>
                <td class="col-4" mat-cell *matCellDef="let element" class="col-2">
                    <div class="d-flex align-items-center justify-content-space-between" *ngIf="element?.male || element?.female">
                        <i class="fas fa-male mr-1" style="color: #B9CFF9 !important;"></i>
                        <span class="progress " style = "width: 70%;">

                            <span class="progress-bar" role="progressbar" matTooltip="Men" [matTooltipClass]="{ 'red-tooltip text-black': true }" [ngStyle]="{'width.%': element.male}"  style="background-color: #B9CFF9!important;" aria-valuenow="element.male" aria-valuemin="0" aria-valuemax="100"></span>
                            <span class="progress-bar" matTooltip="Women" [matTooltipClass]="{ 'red-tooltip text-black': true }" style="background-color: #FFD6F3!important;" role="progressbar" [ngStyle]="{'width.%': element.female}" aria-valuenow="element.female" aria-valuemin="0" aria-valuemax="100"></span>
                        </span>
                        <!-- <div class="progress-bar bg-info" role="progressbar" matTooltip="Not Known" [matTooltipClass]="{ 'red-tooltip text-black': true }" [ngStyle]="{'width.%': element.unknown}" aria-valuenow="element.unknown" aria-valuemin="0" aria-valuemax="100"></div> -->
                        <i class="fas fa-female ml-1" style="color: #FFD6F3 !important;"> </i>
                    </div>
                </td>
            </ng-container>

          
             <!-- female -->
             <ng-container matColumnDef="female">
                <th class="" mat-header-cell *matHeaderCellDef style="width: 200px;" mat-sort-header sortActionDescription="Sort by doc female">
                    <p class="text-9696 f-12 ml-6"><i class="fas fa-female" style="color: #FFD6F3!important;"></i> {{tableHeaderObj["Women"]}} </p>
                </th>
                <td mat-cell *matCellDef="let element" class="col-2">
                    <span class="mx-6 text-484b59">{{element?.female != null ? element?.female+'%': '0'}}</span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <!-- <div *ngIf="diversityTable == null || diversityTable.length == 0">
            <p class="text-center small p-5">No data to display</p>
        </div> -->
        <div *ngIf="!diversityTable?.data?.length">
            <div class="loader text-center" *ngIf="!functionemptystate">
                <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
            </div>
            <div class="text-center" *ngIf="functionemptystate">
                <p class="text-center small p-5">No Data Available</p>
            </div>
        </div>
       
    </div>
</div>
<div class="d-flex justify-content-center wccard" *ngIf="totalCount > 6">
    <ngb-pagination [collectionSize]="totalCount" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSize" rotate="false" (pageChange)="setPage($event)" [(page)]="currentPage" [ellipses]="false">
      <ng-template ngbPaginationPrevious> Previous </ng-template>
      <ng-template ngbPaginationNext> Next </ng-template>
    </ngb-pagination>
</div>